import React from "react";
import styled from "styled-components";
import { Modal, colors2, UI_BODY_SEMIBOLD } from "oolib";
import { ButtonGhost } from "oolib/dist/v2/components/Buttons";

/**
 * Frame for the integration popups: header (icon, title, close), a body that
 * renders `children`, and an optional `footer` bar. The close × and backdrop
 * call `onClose`. Passing `onBack` swaps the icon for a back arrow, for drill-in
 * views like one dataset.
 */

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 14px;
`;

const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

// No top padding: the header's 14px bottom padding is the whole gap.
const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 14px 14px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px;
  border-top: 1px solid ${colors2.grey10};
`;

// Grey info box for text inside the popups, e.g. what an import will do.
export const Description = styled.div`
  padding: 8px 12px;
  border-radius: 6px;
  background: ${colors2.grey5};
`;

export const IntegrationModalShell = ({
  title,
  Icon,
  onBack,
  children,
  onClose,
  footer,
  hideBackdrop,
}) => (
  // overflowVisible: without it the modal clips its content, cutting off
  // popovers that can't portal out (e.g. the v1 date picker's calendar).
  // Same as DirectDataImport's ImportModalShell.
  <Modal
    fitToContentHeight
    overflowVisible
    desktopWidth="640px"
    onClose={onClose}
    title={title}
    disableHeader
    hideBackdrop={hideBackdrop}
  >
    <Header>
      <HeaderTitle>
        {onBack ? (
          <ButtonGhost icon="ArrowLeft" onClick={onBack} />
        ) : (
          Icon && <Icon size={24} />
        )}
        <UI_BODY_SEMIBOLD>{title}</UI_BODY_SEMIBOLD>
      </HeaderTitle>
      <ButtonGhost icon="X" onClick={onClose} />
    </Header>

    <Body>{children}</Body>

    {footer && <Footer>{footer}</Footer>}
  </Modal>
);

export default IntegrationModalShell;
